import { useState, useEffect } from 'react'

/**
 * Hook to detect mobile keyboard height using the visualViewport API.
 * Returns the keyboard height in pixels (0 when keyboard is closed).
 *
 * When the keyboard opens on iOS Safari:
 * - window.innerHeight stays constant (the layout viewport)
 * - visualViewport.height shrinks to the visible area above keyboard
 * - The difference gives us the keyboard height
 */
export function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return

    const updateKeyboardHeight = () => {
      // When keyboard opens, visualViewport.height shrinks
      // The difference between window.innerHeight and viewport.height is ~keyboard height
      const keyboardH = window.innerHeight - viewport.height
      setKeyboardHeight(Math.max(0, keyboardH))
    }

    viewport.addEventListener('resize', updateKeyboardHeight)
    viewport.addEventListener('scroll', updateKeyboardHeight)

    // Initial check
    updateKeyboardHeight()

    return () => {
      viewport.removeEventListener('resize', updateKeyboardHeight)
      viewport.removeEventListener('scroll', updateKeyboardHeight)
    }
  }, [])

  return keyboardHeight
}
